import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import t from '../../service/translate.service'
import { Link } from 'react-router-dom'
import { RepairsAndInquiriesImage, ContractsImage } from '../../components/icons'
import LoadingPageOverlay from '../../components/LoadingPageOverlay'
import MultipaneLayout from '../../components/MultipaneLayout'
import { RepairsAndInquiriesItems, RepairsAndInquiriesContent } from '.'
import RepairsAndInquiriesStore from '../../store/repairsAndInquiries.store'
import NoContent from '../../components/NoContent'
import propTypes from 'prop-types'
import RepairsAndInquiriesSideBar from './RepairsAndInquiriesSideBar'
import historyService from '../../service/history.service'
import { isEmpty } from 'lodash'

const tabStatuses = [
  {
    id: '1',
    name: 'New',
    nameDe: 'Neu'
  },
  {
    id: '2',
    name: 'In progress',
    nameDe: 'In Bearbeitung'
  },
  {
    id: '3',
    name: 'Resolved',
    nameDe: 'Abgeschlossen'
  }
]

class RepairsAndInquiries extends Component {
  static propTypes = {
    contractStore: propTypes.object.isRequired
  }
  constructor (props) {
    super(props)

    this.store = new RepairsAndInquiriesStore()
    this.amendment = ''
    this.store.getReports(0, this.store.pageSize)
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
  }

  onItemClick = id => {
    this.store.submitted = false
    this.store.selectedReport = this.store.reports.find(r => r.code === id)
    this.store.showSuccessMessage = false
    this.store.showAmendForm = false
    this.store.onAmendInput('')
  }
  toggleAmendForm = () => {
    this.store.submitted = false
    this.store.onAmendInput('')
    this.store.showAmendForm = !this.store.showAmendForm
  }
  submitAmendment = (e, reportId) => {
    e.preventDefault()
    this.store.loading = true
    this.store.submitAmendment(reportId, this.store.amendment)
  }
  goToNewRequestPage = () => {
    this.props.navigate('/repairs-and-inquiries/new-request')
  }
  render () {
    const { reports, loading, selectedReport, showAmendForm, showSuccessMessage, statuses, excludedFiles, activeStatus } = this.store
    const actions = [
      {
        classes: 'primary',
        text: t.NEW_REQUEST,
        onClick: this.goToNewRequestPage
      }]
    if (loading) {
      return <LoadingPageOverlay />
    }
    if (isEmpty(this.props.contractStore.selectedContract)) {
      return (
        <div>
          <div className='text-center'>
            <Link to='/contracts/add-contract' className='button primary'
            style={{ marginBottom: '30px' }}
            onClick={() => historyService.push('/contracts/add-contract')}>
              {t.ADD_A_CONTRACT_BUTTON}
            </Link>
          </div>
          <NoContent message={t.NO_CONTRACTS} image={ContractsImage} />
        </div>
      )
    }
    if (!reports.length && activeStatus === '0') {
      return (
        <div className='text-center'>
          <Link to='/repairs-and-inquiries/new-request'
            className='primary button'
            style={{ marginBottom: '30px' }}
            onClick={() => historyService.push('/repairs-and-inquiries/new-request')}>{t.NEW_REQUEST}</Link>
          <NoContent
            message={t.NO_REPORTS}
            image={RepairsAndInquiriesImage}
          />
        </div>
      )
    }
    return (
      <div role="main">
        <div className="reports" aria-live="polite">
          {(reports?.length > 0 && this.store.activeStatus === '0' || this.store.activeStatus !== '0')  && (
            <div className='filter-by-status-wrapper'>
              <div className='status-tabs-holder'>
                <button
                  type='button'
                  aria-label={localStorage.getItem('locale') === 'en' ? 'All cases' : 'Alle Fälle'}
                  onClick={() => this.store.changeStatus('0')}
                  key={0}
                  className={`status-tab-holder ${this.store.activeStatus === '0' ? 'active' : ''}`}
                >
                  {localStorage.getItem('locale') === 'en' ? 'All' : 'Alle'}
                </button>
                {tabStatuses?.map((status) => {
                  return (
                    <button
                      type='button'
                      onClick={() => {
                        this.store.changeStatus(status.id)
                      }}
                      key={status?.id}
                      className={`status-tab-holder ${this.store.activeStatus === status?.id ? 'active' : ''}`}
                    >
                      {localStorage.getItem('locale') === 'en' ? status?.name : status?.nameDe}
                    </button>
                  )
                })}
              </div>
            </div>
          )}
          <div className="multipane-group">
            <MultipaneLayout>
              <section aria-labelledby="repairs-and-inquiries-items">
                <h2 id="repairs-and-inquiries-items" className="sr-only">
                  Repairs and Inquiries List
                </h2>
                <RepairsAndInquiriesItems
                  items={reports}
                  selectedItem={selectedReport}
                  handleClick={this.onItemClick}
                  actions={actions}
                  store={this.store}
                  aria-label={t.REPAIRS_AND_INQUIRIES_LIST}
                />
              </section>
              
              <RepairsAndInquiriesSideBar
                items={reports}
                selectedItem={selectedReport}
              />
              
              <section
                aria-labelledby="repairs-and-inquiries-content"
                role="region"
                aria-live="polite"
              >
                <h2 id="repairs-and-inquiries-content" className="sr-only">
                  Repairs and Inquiries Content
                </h2>
                <RepairsAndInquiriesContent
                  addFile={this.store.addFile}
                  files={this.store.files}
                  item={selectedReport}
                  submitAmendment={this.submitAmendment}
                  excludedFiles={excludedFiles}
                  onAmendInput={this.store.onAmendInput}
                  getAttachments={this.store.getAttachments}
                  getTicketById={this.store.getTicketById}
                  amendment={this.store.amendment}
                  showAmendForm={showAmendForm}
                  selectedItem={selectedReport}
                  toggleAmendForm={this.toggleAmendForm}
                  error={this.store.error}
                  showSuccessMessage={showSuccessMessage}
                  statuses={statuses}
                  validators={this.store.validators}
                  aria-label={t.REPAIRS_AND_INQUIRIES_DETAILS}
                />
              </section>
            </MultipaneLayout>
          </div>
        </div>
      </div>
    );
  }
}

export default inject(
  'contractStore'
)(observer(RepairsAndInquiries))
